export const AVITO_PARTNER_ID = '8d9fa905-4894-49ec-b168-88d5dd328257'
export const BUYOUT_GOAL_ID = 'cc08b5b6-8c7a-4b40-a410-84b76638809f'
